import Search from './SeachApp';

export default Search;
